import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { useSeo } from "@/hooks/useSeo";

export function LegalPage({ title, updated, seoDescription, testId, children }) {
  useSeo({ title: `${title} | PlanPermis`, description: seoDescription });
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid={testId}>
      <header className="border-b border-neutral-200 bg-white px-6 py-4 sm:px-12 lg:px-20">
        <Link to="/" data-testid="legal-home-link">
          <Logo className="h-10" />
        </Link>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-12">
        <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl" data-testid="legal-title">
          {title}
        </h1>
        {updated && <p className="mt-2 text-sm text-neutral-400">Dernière mise à jour : {updated}</p>}
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-neutral-700">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-bold tracking-tight text-neutral-900">{title}</h2>
      {children}
    </section>
  );
}

export default LegalPage;
